import React from 'react';
import { HttpService } from 'core/services/http';

/**
 * Component that renders children only for authenticated users (any role)
 */
function UserView({ children, fallback = null }) {
    const token = HttpService.getToken();
    const user = HttpService.getUser();
    const isAuthenticated = !!token && !!user;

    if (isAuthenticated) {
        return <>{children}</>;
    }

    return fallback;
}

export default UserView;

